export default {
  ACTION_BUTTON: 'Action Button',
  AUDIO: 'Audio',
  BUTTON: 'Button',
  CAROUSEL: 'Carousel',
  CONDITION: 'Condition',
  ECOMMERCE: 'Ecommerce',
  CAROUSEL_ITEM: 'Carousel Single',
  COMPONENT_LIST: 'Component List',
  FACEBOOK_MEDIA: 'Facebook Media',
  FILE: 'File',
  GENERIC_TEMPLATE: 'Generic Template',
  IMAGE: 'Image',
  POSTBACK_NEW: 'New Postback',
  OTN: 'OTN',
  OTN_SINGLE: 'OTN Single',
  QUICK_REPLY: 'Quick Reply',
  POSTBACK: 'Start Bot Flow',
  SEQUENCE: 'New Sequence',
  SEQUENCE_SINGLE: 'Sequence Single',
  TEXT: 'Text',
  TRIGGER: 'Trigger',
  USER_INPUT_FLOW: 'User Input Flow',
  USER_INPUT_FLOW_SINGLE: 'User Input Flow Single',
  VIDEO: 'Video',
  RECURRING_NOTIFICATION: 'Recurring Notification',
  RCN_SINGLE: 'RCN Single',
  OPEN_AI: 'Open AI',
}